<template>
  <div :class="['scrollbar-wrapper', { horizontal }]">
    <div class="scrollbar-wrapper__scrollbar">
      <div
        class="scrollbar-wrapper__scrollbar__progress"
        :style="{
          ...(horizontal
            ? { width: `${state.progress}%` }
            : { height: `${state.progress}%` }),
        }"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive } from "@vue/runtime-core";

const props = defineProps({
  scrollContainerId: String,
  // Set true for horizontal scrollbars
  horizontal: Boolean,
});

const state = reactive({
  scrollContainer: null,
  progress: 0,
});

onMounted(() => {
  state.scrollContainer = document.getElementById(props.scrollContainerId);

  if (state.scrollContainer) {
    state.scrollContainer.classList.add("hide-scrollbar");
    state.scrollContainer.addEventListener("scroll", handleScrolling);
  }
});

function handleScrolling() {
  if (state.scrollContainer) {
    let scrollSize = state.scrollContainer.scrollHeight;
    let clientSize = state.scrollContainer.clientHeight;
    let scrollStart = state.scrollContainer.scrollTop;

    if (props.horizontal) {
      scrollSize = state.scrollContainer.scrollWidth;
      clientSize = state.scrollContainer.clientWidth;
      scrollStart = state.scrollContainer.scrollLeft;
    }
    const progress = scrollSize - clientSize;

    state.progress = Math.floor((scrollStart * 100) / progress);
  }
}
</script>

<style lang="scss" scoped>
.scrollbar-wrapper {
  position: absolute;
  width: 0.4rem;
  height: var(--scrollbar-height, 85%);
  top: calc(var(--modal-padding) * 1.5);
  right: calc(var(--modal-padding) * 0.5 + 0.5rem);

  &.horizontal {
    height: 0.4rem;
    width: var(--scrollbar-width, 100%);
  }

  &__scrollbar {
    width: 100%;
    height: 100%;
    background: var(--scala-grigi-gray-5);

    &__progress {
      border-radius: 6px;
      background: var(--primary-yellow);
      opacity: 1;

      .horizontal & {
        height: 100%;
      }
    }
  }

  .mobile & {
    height: 100%;
  }
}
</style>

<style lang="scss">
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
